import { DfyOrderLineItem } from "@repo/api/dfy";
import { DfyCouponDto } from "@repo/api/coupon";
import { ReactNode } from "react";
import { formatDfyCreditsToPrice } from "../dfy-order-form-content";

export default function CostBreakdown({
  lineItems,
  coupon,
  creditsFromBalance,
  total,
  showTitle = true,
  titleAccessory,
}: {
  lineItems: DfyOrderLineItem[];
  coupon: DfyCouponDto | null;
  creditsFromBalance: number;
  total: number;
  showTitle?: boolean;
  titleAccessory?: ReactNode;
}) {
  return (
    <div className="flex flex-col gap-3">
      {showTitle && (
        <div className="flex items-center justify-between gap-4">
          <p className="font-medium">Cost breakdown</p>
          {titleAccessory}
        </div>
      )}
      <div className="flex flex-col gap-2 rounded-xl border p-4 text-sm">
        {lineItems.length === 0 ? (
          <p className="text-text-secondary">
            Choose a package to see pricing.
          </p>
        ) : (
          lineItems.map((item, index) => (
            <div
              key={item.id}
              className={`flex items-center justify-between gap-4 ${
                index === 0 ? "" : "text-text-secondary"
              }`}
            >
              <span>{item.label}</span>
              <span className="shrink-0 font-medium">
                {index === 0
                  ? formatDfyCreditsToPrice(item.credits)
                  : `+${formatDfyCreditsToPrice(item.credits)}`}
              </span>
            </div>
          ))
        )}
        {coupon && (
          <div className="flex items-center justify-between gap-4 text-text-secondary">
            <span>Coupon ({coupon.code})</span>
            <span className="shrink-0 font-medium">
              -{formatDfyCreditsToPrice(coupon.credits)}
            </span>
          </div>
        )}
        {creditsFromBalance > 0 && (
          <div className="flex items-center justify-between gap-4 text-text-secondary">
            <span>Credits</span>
            <span className="shrink-0 font-medium">
              -{formatDfyCreditsToPrice(creditsFromBalance)}
            </span>
          </div>
        )}
        <div className="mt-1 flex items-center justify-between gap-4 border-t pt-3 font-medium">
          <span>Total</span>
          <span>{formatDfyCreditsToPrice(total)}</span>
        </div>
      </div>
    </div>
  );
}
